import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Label, Text } from 'recharts';

// const colors = ['#1F337E', '#3E66FB', '#9EB2FD', '#CFD9FE', '#DBE3FF'];

const renderLegend = (value, props) => {
  const { payload } = props;
  return (
      <div className='flex gap-2'>
        <p className='text-grey-100'>{value}</p>
        <p className='text-lightblack font-medium'>{payload?.value}</p>
      </div>
  );
};

const PieCharts = ({ data, legendHide, colors=[] }) => {

  return (
    <ResponsiveContainer height={206}>
      <PieChart height={64} width={64}>
        <Pie
          data={data}
          cx="38%"
          cy="50%"
          innerRadius="60%"
          outerRadius="80%"
          fill="#8884d8"
          // paddingAngle={3}
          dataKey="value"
          cornerRadius={0}
          legendType="cross"
        >
          {
            data?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))
          }
        </Pie>
        <Label width={30} position="center">
          +74%
        </Label>
        {
          !legendHide &&
          <Legend
            wrapperStyle={{top: 0, right: 0,}}
            iconType="plainline"
            layout="vertical"
            verticalAlign="middle"
            iconSize={30}
            formatter={renderLegend}
          />
        }
      </PieChart>
    </ResponsiveContainer>
  );
}

export default PieCharts;
